import React from "react";
import {
  PriceRangeButton,
  ChevronContainer,
  PriceRangeLabel,
  StyledChevronIcon,
} from "./styles";

interface FilterDropDownBtnProps {
  label: string;
  onClick: () => void;
  active?: boolean;
}

const FilterDropDownBtn: React.FC<FilterDropDownBtnProps> = ({
  label,
  onClick,
  active = false,
}) => {
  return (
    <PriceRangeButton
      onClick={onClick}
      style={{
        borderColor: active ? "#5B3FFF" : "#E3E6F0",
        color: active ? "#5B3FFF" : "#42536A",
      }}
    >
      {/* Chevron Icon (left) */}
      <ChevronContainer>
        <StyledChevronIcon
          style={{
            fill: active ? "#5B3FFF" : "#75849F",
          }}
        />
      </ChevronContainer>
      {/* Label (right) */}
      <PriceRangeLabel
        style={{
          color: active ? "#5B3FFF" : "#42536A",
        }}
      >
        {label}
      </PriceRangeLabel>
    </PriceRangeButton>
  );
};

export default FilterDropDownBtn;
